import React, { Fragment } from "react";
import CustomPropTypes from "../../utils/customPropTypes";
import ImageBlock from "../ImageBlock";
import SafeHTML from "../SafeHTML";

export default class ProductCard extends React.Component {
  static propTypes = {
    product: CustomPropTypes.Product
  };
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      isMobile : false,
      isColorFlexL2Page : false,
      isProductPageCard : false,
      isNewDesign: false,

    };
  }

  // static getDerivedStateFromProps(props, state) {
  //   return {
  //     active: false
  //   };
  // }

  toggleClass = (event) => {
    // const currentState = this.state.active;
    // this.setState({ active: !currentState });
    const element = event.currentTarget; // Get the element that triggered the event
    element.classList.toggle("active");
  };

  componentDidMount(){
    
    let isMobileView = window.matchMedia("(max-width: 500px)").matches
    this.setState({isMobile: isMobileView})
    let isColorFlexL2 = window.location.pathname.includes("colorflex-l2")
    let isProductPage = window.location.pathname.includes("product")

    let endpoint = window.location.pathname.split('/').filter(Boolean).pop();

    if(endpoint==="products" || endpoint==="benchtop-spectrophotometers"){
      this.setState({isNewDesign:true})
    }

    if(isColorFlexL2){
        this.setState({isColorFlexL2Page : isColorFlexL2})
    }
    if(isProductPage){
      this.setState({isProductPageCard : isProductPage})
  }
  }

  render() {
    const {isaccesossoryCard} = this.props
    var isProductPage = window.location.pathname.includes("product")
    let objProduct = this.props.product;
    const pathname = window.location.pathname;
    
    const title1Replacement = "ColorFlex EZ - For semi–solid shortening";
    const title2Replacement = "Vista - For liquid shortening";
    const title3Replacement = "Vista - For liquids";
    const title4Replacement = "ColorFlex EZ - For powders";
    const title5Replacement = "UltraScan VIS - For liquids and powders";
    const title6Replacement = "Vista - Para bebidas líquidas";
    const title7Replacement = "ColorFlex EZ - Para bebidas en polvo";
    const title8Replacement = "UltraScan VIS - Para bebidas líquidas y en polvo";

    const title9Replacement = "ColorFlex EZ - For small pellets/granules and measurement of canned food in a cup";
    const title10Replacement = "Aeros- non-homogeneous and canned items, large treats";
    const title11Replacement = "ColorFlex EZ - Para pequeños pellets/gránulos y medición de comida enlatada en un recipiente.";
    const title12Replacement = "Aeros - Para golosinas más grandes, comida para mascotas no homogénea y productos enlatados.";
    const title13Replacement = "ColorFlex L2 - For Powders";
    const title14Replacement = "ColorFlex L2 - Para Polvos";

  
    if (objProduct) {
      
      let cardTitle = objProduct.name;
      let [productName, productCode] = cardTitle.split(',');
  
  
      if (pathname.includes("/measuring-the-color-of-shortening")) {
        if (objProduct.name === "ColorFlex EZ") {
          cardTitle = title1Replacement;
        } else if (objProduct.name === "Vista") {
          cardTitle = title2Replacement;
        }
      }

      if (pathname.includes("/food/measuring-the-color-of-pet-food/")) {
        if (objProduct.name === "ColorFlex EZ") {
          cardTitle = title9Replacement;
        } else if (objProduct.name === "Aeros") {
          cardTitle = title10Replacement;
        }
      }

      if (pathname.includes("/es/industries/food/measuring-the-color-of-pet-food/")) {
        if (objProduct.name === "ColorFlex EZ") {
          cardTitle = title11Replacement;
        } else if (objProduct.name === "Aeros") {
          cardTitle = title12Replacement;
        }
      }

      if (pathname.includes("/measuring-the-color-of-tea-drinks")) {
        if (objProduct.name === "Vista") {
          cardTitle = title3Replacement;
        } else if (objProduct.name === "ColorFlex EZ") {
          cardTitle = title4Replacement;
        } else if (objProduct.name === "ColorFlex L2") {
          cardTitle = title13Replacement;
        } else if (objProduct.name === "UltraScan VIS") {
          cardTitle = title5Replacement;
        }
      }

      if (pathname.includes("/measuring-the-color-of-functional-beverages")) {
        if (objProduct.name === "Vista") {
          cardTitle = title3Replacement;
        } else if (objProduct.name === "ColorFlex EZ") {
          cardTitle = title4Replacement;
        } else if (objProduct.name === "ColorFlex L2") {
          cardTitle = title13Replacement;
        } else if (objProduct.name === "UltraScan VIS") {
          cardTitle = title5Replacement;
        }
      }

      if (pathname.includes("/measuring-the-color-of-sports-drinks")) {
        if (objProduct.name === "Vista") {
          cardTitle = title3Replacement;
        } else if (objProduct.name === "ColorFlex EZ") {
          cardTitle = title4Replacement;
        } else if (objProduct.name === "ColorFlex L2") {
          cardTitle = title13Replacement;
        } else if (objProduct.name === "UltraScan VIS") {
          cardTitle = title5Replacement;
        }
      }

      if (pathname.includes("/es/industries/beverages/liquid-beverages/measuring-the-color-of-tea-drinks")) {
        if (objProduct.name === "Vista") {
          cardTitle = title6Replacement;
        } else if (objProduct.name === "ColorFlex EZ") {
          cardTitle = title7Replacement;
        } else if (objProduct.name === "ColorFlex L2") {
          cardTitle = title14Replacement;
        } else if (objProduct.name === "UltraScan VIS") {
          cardTitle = title8Replacement;
        }
      }

      if (pathname.includes("/es/industries/beverages/liquid-beverages/measuring-the-color-of-functional-beverages")) {
        if (objProduct.name === "Vista") {
          cardTitle = title6Replacement;
        } else if (objProduct.name === "ColorFlex EZ") {
          cardTitle = title7Replacement;
        } else if (objProduct.name === "ColorFlex L2") {
          cardTitle = title14Replacement;
        } else if (objProduct.name === "UltraScan VIS") {
          cardTitle = title8Replacement;
        }
      }

      if (pathname.includes("/es/industries/beverages/liquid-beverages/measuring-the-color-of-sports-drinks")) {
        if (objProduct.name === "Vista") {
          cardTitle = title6Replacement;
        } else if (objProduct.name === "ColorFlex EZ") {
          cardTitle = title7Replacement;
        } else if (objProduct.name === "ColorFlex L2") {
          cardTitle = title14Replacement;
        } else if (objProduct.name === "UltraScan VIS") {
          cardTitle = title8Replacement;
        }
      }
    
      const titleParts = cardTitle.split(' - ');
      const productCardTitle = cardTitle.replace(')','');
      let endpoint = window.location.pathname.split('/').filter(Boolean).pop();
      if(this.state.isColorFlexL2Page || endpoint ==="products" || endpoint==="benchtop-spectrophotometers"){
      return (
        <>
          <a
            // style={{height:(isaccesossoryCard && this.state.isMobile) ? "400px" : ""}}
            href={objProduct.url}
            // className={"product-card product-card-new" + (this.state.active ? " active" : "") +  ((this.props.isaccesossoryCard && this.state.isColorFlexL2Page) ? "colorflex-l2-accessory-card accessory-card-product" : this.props.isaccesossoryCard ? "accessory-card-product": "")}
            className={
              "product-card product-card-new product-card-title" +
              (this.state.active ? " active" : "") +
              (this.props.isaccesossoryCard && this.state.isColorFlexL2Page
                ? " colorflex-l2-accessory-card accessory-card-product"
                : this.props.isaccesossoryCard
                ? " accessory-card-product"
                : (this.state.isProductPageCard && !this.state.isColorFlexL2Page)
                ? " products-page-card"
                : "")
            }
            onClick={(e) => {
              this.toggleClass(e);
            }}
          >
            <div className="product-card-inner">
              <h4 className={isaccesossoryCard ? "accessories-title" :"product-card-title"}>
                {/* {titleParts.length > 1 ? (
                  <>
                    <span className="h4-text">{titleParts[0]}</span>
                    <br />
                    <span className="h5-text">{titleParts[1]}</span>
                  </>
                ) : (
                  <>
                  <b><span className="h4-text">{`${productCardTitle.split('(')[0]}`}</span></b>
                  {cardTitle.split('(')[1] &&(<p>{`${productCardTitle.split('(')[1]}`}</p>)}
                  </>
                )} */}
                <span className="h4-text">{cardTitle}</span>

              </h4>

              {/* <div className="product-card-data-Not-Hover">
                <SafeHTML>{isaccesossoryCard ? this.props?.product?.name?.split(',')[1]  :  ""}</SafeHTML>
              </div> */}
  
              <div className={isaccesossoryCard ?"product-card-data accessory-card-data":"product-card-data"}>
                <SafeHTML>{objProduct.description}</SafeHTML>
              </div>
              <div className={isaccesossoryCard ? "product-card-object accessory-obj" :"product-card-object"}>
                <ImageBlock image={objProduct.image} addWrapper={false} />
              </div>
              <div className="product-card-action">
              <span className={isaccesossoryCard ? "accessories-name" : "learn_more"}>{isaccesossoryCard ? (this.props?.product?.name?.includes("%%%") ? (<>{this.props.product.name.split("%%%")[0]}<br />{this.props.product.name.split("%%%")[1].split(',')[0]}</>) : (this.props?.product?.name?.split(',')[0])) : ("Learn More")}</span>
                <i className={this.state.isNewDesign?"icon icon-direction-right new-design-arrow-icon":"icon icon-direction-right"}></i>
              </div>
            </div>
  
            <div className="product-card-hover">
              <h4 className={isaccesossoryCard ? "accessories-title" :"product-card-title"}>
              {/* <b><span className="h4-text">{`${productCardTitle.split('(')[0]}`}</span></b>
              {cardTitle.split('(')[1] &&(<p>{`${productCardTitle.split('(')[1]}`}</p>)} */}

                <span className="h4-text">{cardTitle}</span>

              </h4>

              <div className="product-card-data-hover">
                <SafeHTML>{isaccesossoryCard ? this.props?.product?.name?.split(',')[1]  :  ""}</SafeHTML>
              </div>

              <div className="product-card-data-witb">
                <SafeHTML>{objProduct.description}</SafeHTML>
              </div>
              <div className="product-card-action">
                <span className={isaccesossoryCard ? "accessories-name" :"learn_more"}>{isaccesossoryCard ? this.props?.product?.name  :  "Learn More"}</span>
                <i className={this.state.isNewDesign?"icon icon-direction-right new-design-arrow-icon":"icon icon-direction-right"}></i>
              </div>
            </div>
          </a>
        </>
      );
    } else {
      return (
        <>
            <a
              href={objProduct.url}
              className={"product-card product-card-new products-page-card" + (this.state.active ? " active" : "")}
              onClick={(e) => {
                this.toggleClass(e);
              }}
            >
              <div className="product-card-inner">
              <h4 className="product-card-title"><span className="h4-text">{cardTitle}</span></h4>
                <div className="product-card-data">
                  <SafeHTML>{objProduct.description}</SafeHTML>
                </div>
                <div className="product-card-object">
                  <ImageBlock image={objProduct.image} addWrapper={false} />
                </div>
                <div className="product-card-action">
                <span className="learn_more">Learn More</span>
                  <i className="icon icon-direction-right new-design-arrow-icon"></i>
                </div>
              </div>
    
              <div className="product-card-hover">
                <h4 className="product-card-title"><span className="h4-text">{cardTitle}</span></h4>
                <div className="product-card-data in">
                  <SafeHTML>{objProduct.description}</SafeHTML>
                </div>
                <div className="product-card-action">
                <span className="learn_more">Learn More</span>
                  <i className="icon icon-direction-right new-design-arrow-icon"></i>
                </div>
              </div>
            </a>
          </>
  
      );
    } 
  }else {
    return(
      <>
          <a
            href={objProduct.url}
            className={"product-card product-card-new products-page-card" + (this.state.active ? " active" : "")}
            onClick={() => {
              this.toggleClass();
            }}
          >
            <div className="product-card-inner">
              <h4 className="product-card-title"> 
                  <span className="h4-text">{cardTitle}</span>
              </h4>
  
              <div className="product-card-data">
                <SafeHTML>{objProduct.description}</SafeHTML>
              </div>
              <div className="product-card-object">
                <ImageBlock image={objProduct.image} addWrapper={false} />
              </div>
              <div className="product-card-action">
              <span className="learn_more">Learn More</span>
                <i className="icon icon-direction-right new-design-arrow-icon"></i>
              </div>
            </div>
  
            <div className="product-card-hover">
              <h4 className="product-card-title"><span className="h4-text">{cardTitle}</span></h4>
              <div className="product-card-data">
                <SafeHTML>{objProduct.description}</SafeHTML>
              </div>
              <div className="product-card-action">
              <span className="learn_more">Learn More</span>
                <i className="icon icon-direction-right new-design-arrow-icon"></i>
              </div>
            </div>
          </a>
        </>

    )
  }
  }
}
